

/**
 * 贴地面积测量
 */

import DrawPolygon from "../plot/DrawPolygon"
import ConstantDraw from "../constants/ConstantDraw"
import { getArea, formatArea } from "./utils/space"
import { interPolygon, getAreaOfTriangle } from "./utils/index"
import { createWorkerByFunction, createWorkerByCode } from "@/utils/cesiumBD/utils/Worker"
class AreaGround extends DrawPolygon {

    constructor(options) {
        super(options);
        this.options = options;
        this.sum = "正在计算,请稍后...";
        this.entitiesLabel = [];
        this.centerPos = undefined;
    }

    initEditor() {
    }

    leftClick(evt) {
        super.leftClick(evt); //调用
        var $this = this;
        var l = $this.positions.length;
        var p = this.createPoint($this.positions[l-1], ConstantDraw.Style_KeyPos);
        this.entitiesLabel.push(p);
    }
    rightClick(evt){
        var $this = this;
        var l = $this.positions.length;
        var end = $this.positions[l - 1];
        var p = this.createPoint(end, ConstantDraw.Style_KeyPos);
        this.entitiesLabel.push(p);
        super.rightClick(evt); //调用
    }
    initCenterPoint() {
        var keyPos = this.positions; //拿到关键点数组
        var posArr = this.cart2Wgs84(keyPos);
        var center = this.getCenter(posArr);
        var cart = Cesium.Cartesian3.fromDegrees(center[0], center[1]);
        this.centerPos = this.createPoint(cart);
        this.entities.push(this.centerPos);
        this.entitiesLabel.push(this.centerPos);
        this.plot.position = cart;
    }
    leftDoubleClick(evt) {
        this.initCenterPoint();
        super.leftDoubleClick(evt);
        this.getArea();
    }
    reset() {
        super.reset();
        this.entitiesLabel = [];
    }
    clear(){
        super.clear();
        this.entitiesLabel = [];
    }
    initKeyPositions() {
        this.plot.attrPlot = {
            edit_positions: this.positions.slice(),
            entitiesLabel: this.entitiesLabel.slice()
        }; //标绘标识
        this.initCenterPoint();
    }
    getArea() {
        this.sum = "正在计算,请稍后...";
        //var p = this.centerPos//实体
        var lable = ConstantDraw.Style_Label;
        lable.text = this.sum;
        this.plot.label = lable;
        var that = this;
        ///////////////////////

        //     const workCode = `
        //     onmessage = (e) => {
        //         postMessage('你好，我是子进程！');
        //     }
        // `
        // const workCode = function workCodeFun() {
        //     onmessage = (e) => {

        //         var positions = e.data.positions;
        //         // var Cesium = e.data.Cesium;
        //         console.log(positions);
        //         console.log(globeObject);
        //         var scene = e.data.scene;
        //         // interPolygon({
        //         //     positions: positions,
        //         //     scene: scene,
        //         //     splitNum: 50,
        //         //     has3dtiles: false,
        //         //     asyn: true,
        //         //     calback: function calback(resultInter) {
        //         //         postMessage('你好，我是子进程！', resultInter);
        //         //         // var area = _restultArea(resultInter);
        //         //         // if (options.calback) options.calback(area, resultInter);
        //         //     }
        //         // });

        //     }
        // }

        // var work = createWorkerByFunction(workCode);
        // work.postMessage({
        //     positions: this.positions,
        //     //Cesium:Cesium
        // })
        // work.onmessage = (e) => {
        //     console.log(`主进程收到了子进程发出的信息：${e.data}`);
        //     // 主进程收到了子进程发出的信息：你好，我是子进程！
        //     work.terminate();
        // };


        ///////////////////////
        this.getClampArea(this.positions, {
            scene: this.viewer.scene,
            asyn: true,
            splitNum: 10,
            calback: (res, inter) => {
                this.sum = `贴地面积:${formatArea(res)}`
                this.plot.label.text = this.sum;
            }
        });
    }

    getClampArea(positions, options) {
        function _restultArea(resultInter) {
            var area = 0; //总面积(贴地三角面) 
            for (var i = 0, len = resultInter.list.length; i < len; i++) {
                var item = resultInter.list[i];
                var pt1 = item.point1;
                var pt2 = item.point2;
                var pt3 = item.point3;

                //求面积 
                area += getAreaOfTriangle(pt1.pointDM, pt2.pointDM, pt3.pointDM);
            }
            return area;
        }

        var resultInter = interPolygon({
            positions: positions,
            scene: options.scene,
            splitNum: options.splitNum,
            has3dtiles: options.has3dtiles,
            asyn: options.asyn,
            calback: function calback(resultInter) {
                var area = _restultArea(resultInter);
                if (options.calback) options.calback(area, resultInter);
            }
        });

        if (!options.asyn) {
            var area = _restultArea(resultInter);
            if (options.calback) options.calback(area, resultInter);
        }
    }

    cart2Wgs84(cartesain3Array) {
        let cartographics = Cesium.Ellipsoid.WGS84.cartesianArrayToCartographicArray(cartesain3Array);
        return cartographics.map(carto => {
            return [Cesium.Math.toDegrees(carto.longitude), Cesium.Math.toDegrees(carto.latitude)]
        })
    }

    //获取中心点
    getCenter(arr) {
        let centerLonLat = []
        if (arr.length) {
            const lon = []
            const lat = []
            const poly = [];
            for (let i = 0, len = arr.length; i < len; i++) {
                lon.push(arr[i][0])
                lat.push(arr[i][1])
            }
            for (let i = 0, len = lon.length; i < len; i++) {
                poly.push({
                    x: parseFloat(lon[i]),
                    y: parseFloat(lat[i]),
                    z: 0
                });
            }
            const sortedLongitudeArray = poly.map(item => item.x).sort();
            const sortedLatitudeArray = poly.map(item => item.y).sort();
            const centerLongitude = ((parseFloat(sortedLongitudeArray[0]) + parseFloat(sortedLongitudeArray[sortedLongitudeArray.length - 1])) / 2).toFixed(14);
            const centerLatitude = ((parseFloat(sortedLatitudeArray[0]) + parseFloat(sortedLatitudeArray[sortedLatitudeArray.length - 1])) / 2).toFixed(14);
            centerLonLat = [Number(centerLongitude), Number(centerLatitude)]
        }
        return centerLonLat;
    }

}

export default AreaGround